<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='80%')
      v-card(color='grey_1')
        v-app-bar(dark color='primary')
          span.headline {{ formTitle }}
        v-card-text
          v-row(dense)
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black') Detalle del Pago
                v-card-text
                  h4 Moneda
                  v-row(dense)
                    v-col(cols='6' sm='4')
                      v-switch(dense color='success' v-model='dolar' label='Dolar')
                    v-col(cols='6' sm='4')
                      v-switch(dense color='success' v-model='bs' label='Bs' )
                  v-row(dense)
                    v-col(cols='12' sm='6' md='4')
                      v-text-field(dense outlined :value='montoPagar | read' label='Saldo deudor' readonly :prefix="form.moneda")
                    v-col(cols='12' sm='6' md='4')
                      v-text-field(dense outlined :value='form.tasaCompra | read' label='Tasa a pagar' readonly prefix="BsS")
                    v-col(cols='12' sm='12' md='12')
                      v-textarea(
                        auto-grow,
                        v-model='form.descripcion',
                        label="Descripción",
                        outlined,
                        dense,
                        v-uppercase)
            v-col(cols='12')
              v-card(color='white')
                v-card-subtitle.title(style='color: black') Forma de Pago
                v-card-text
                  v-card.mx-auto(max-width='100%', outlined class='px-5')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-switch(dense color='success' v-model='act1' label='Efectivo')
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-dialog(ref='dialog1' v-model='modalDate1' :return-value.sync='date' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='pago.fechaPagoEfectivo' :disabled='!act1' label='Fecha de Pago' prepend-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='pago.fechaPagoEfectivo' locale="ES")
                                  v-spacer
                                  v-btn(small dark color='error' @click='modalDate1 = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
                            v-col(cols='6' sm='6' md='6')
                              v-text-field(dense outlined :disabled='!act1' v-model.number='pago.efectivo' hint='Ingrese el Monto del efectivo' label="Monto" :prefix="form.moneda")
                    v-divider
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-switch(dense color='success' v-model='act2' label='Transferencia')
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-dialog(ref='dialog2' v-model='modalDate2' :return-value.sync='date' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='pago.fechaTransferencia' :disabled='!act2' label='Fecha de Transferencia' prepend-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='pago.fechaTransferencia' locale="ES")
                                  v-spacer
                                  v-btn(small dark color='error' @click='modalDate2 = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
                            //- v-col(cols='6' sm='6' md='6')
                            //-   v-dialog(ref='dialog3' v-model='modalDate3' :return-value.sync='date' readonly persistent width='300px')
                            //-     template(v-slot:activator='{ on }')
                            //-       v-text-field( v-model='pago.fechaPagoTransferencia' :disabled='!act2' label='Fecha de Pago' prepend-icon='event' readonly dense outlined v-on='on')
                            //-     v-date-picker( v-model='pago.fechaPagoTransferencia' locale="ES")
                            //-       v-spacer
                            //-       v-btn(small dark color='error' @click='modalDate3 = false') Cancelar
                            //-       v-btn(small dark color='success' @click='$refs.dialog3.save(date)') Ok
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-autocomplete(autocomplete="off" :menu-props="{closeOnContentClick: true}" dense label="Banco" :disabled='!act2' outlined v-model='pago.bancoTransferencia' :items="idBancosArray")
                                template(v-slot:prepend-item v-if="validarCrearBan()")
                                  v-list(dense)
                                    v-list-item( @click='ban = true')
                                      v-list-item-avatar(color='grey_1')
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Banco
                              BancoM(:dialog='ban' :editedIndex='-1' @close='ban = false' @save='listarBancos')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense outlined :disabled='!act2' v-model='pago.referencia' label='Nro. Referencia')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense outlined :disabled='!act2' v-model.number='pago.transferencia' hint='Ingrese el Monto de la Transferencia' label="Monto" :prefix="form.moneda")
                    v-divider
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-switch(dense color='success' v-model='act3' label='Cheque' )
                          v-row(dense)
                            v-col(cols='6' sm='6' md='6')
                              v-dialog(ref='dialog4' v-model='modalDate4' :return-value.sync='date' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='pago.fechaCheque' :disabled='!act3' label='Fecha de Cheque' prepend-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='pago.fechaCheque' locale="ES")
                                  v-spacer
                                  v-btn(small dark color='error' @click='modalDate4 = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog4.save(date)') Ok
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-autocomplete(autocomplete="off" :menu-props="{closeOnContentClick: true}" dense label="Banco" :disabled='!act3' outlined v-model='pago.bancoCheque' :items="idBancosArray")
                                template(v-slot:prepend-item)
                                  v-list(dense)
                                    v-list-item( @click='ban = true')
                                      v-list-item-avatar(color='grey_1')
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Banco
                              BancoM(:dialog='ban' :editedIndex='-1' @close='ban = false' @save='listarBancos')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense outlined :disabled='!act3' v-model='pago.numeroCheque' label='Nro. Cheque')
                            v-col(cols='6' sm='6' md='4')
                              v-text-field(dense outlined :disabled='!act3' v-model.number='pago.cheque' hint='Ingrese el Monto del cheque' label="Monto" :prefix="form.moneda")
                  v-row(class='d-flex justify-end')
                    v-col(cols='6' sm='6' md='4')
                      v-text-field(dense outlined v-model='pago.restante' readonly label='Monto Restante' :prefix="form.moneda")
                    v-col(cols='6' sm='6' md='4')
                      v-text-field(dense outlined v-model='pago.total' readonly label='Monto Total' :prefix="form.moneda")
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click='save')
            v-icon mdi-content-save
            | Guardar
</template>
<script>
import Api from '@/services/methods'
import BancoM from './BancoM'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    ban: false,
    emp: false,
    bs: true,
    dolar: false,
    search: '',
    cuentaXCobrar: [],
    permisosRuta: {},
    idBancosArray: [],
    modalDate1: false,
    modalDate2: false,
    modalDate3: false,
    modalDate4: false,
    modalDate5: false,
    dialog1: false,
    dialog2: false,
    dialog3: false,
    dialog4: false,
    dialog5: false,
    date: new Date().toISOString().substr(0, 10),
    bancos: [],
    checkbox: true,
    act1: false,
    act2: false,
    act3: false,
    montoPagar: 0,

    permisosBan: {},

    form: {
      _id: '',
      descripcion: '',
      debito: 0,
      credito: 0,
      idProveedor: '',
      idCompra: '',
      estatus: '',
      cancelada: false,
      moneda: '',
      tasaCompra: 0,
      // idCuentas: '',
      // descripcion: '',
      // fechaRegistro: '',
      // numFactura: 0,
      // numContol: 0,
      // debito: 0,
      // credito: 0,
      // baseImponible: 0,
      // idConcepto: '',
      // montoGrabado: 0,
      // montoExento: 0,
      // porcentajeComision: 0,
      // idCliente: '',
      // idVenta: '',
      // idVendedor: '',
      // estatus: '',
      // cancelada: false
    },
    defaultItem: {
      descripcion: '',
      debito: 0,
      credito: 0,
      idProveedor: '',
      idCompra: '',
      estatus: '',
      cancelada: false
      // idCuentas: '',
      // descripcion: '',
      // fechaRegistro: '',
      // numFactura: 0,
      // numContol: 0,
      // debito: 0,
      // credito: 0,
      // baseImponible: 0,
      // idConcepto: '',
      // montoGrabado: 0,
      // montoExento: 0,
      // porcentajeComision: 0,
      // idCliente: '',
      // idVenta: '',
      // idVendedor: '',
      // estatus: '',
      // cancelada: false
    },
    pago: {
      efectivo: 0,
      fechaPagoEfectivo: '',
      transferencia: 0,
      fechaTransferencia: '',
      bancoTransferencia: '',
      referencia: '',
      cheque: 0,
      fechaCheque: '',
      bancoCheque: '',
      numeroCheque: '',
      total: 0,
      restante: 0
    }
  }),
  components: {
    BancoM
  },
  computed: {
    formTitle () {
      return 'Cuenta por Pagar'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
        if (val.idCompra.tasaCompra) this.form.tasaCompra = val.idCompra.tasaCompra
        this.form.moneda = 'BsS'
        this.actualizarMontos()
      }
    },
    'pago.efectivo': function (val) {
      if (parseInt(val) <= 0) this.pago.efectivo = 0
      this.calculos()
    },
    'pago.cheque': function (val) {
      if (parseInt(val) <= 0) this.pago.cheque = 0
      this.calculos()
    },
    'pago.transferencia': function (val) {
      if (parseInt(val) <= 0) this.pago.transferencia = 0
      this.calculos()
    },
    'act1': function (val) {
      if (!val) {
        this.pago.efectivo = 0
        this.pago.fechaPagoEfectivo = ''
      }
      this.calculos()
    },
    'act2': function (val) {
      if (!val) {
        this.pago.transferencia = 0
        this.pago.fechaTransferencia = ''
        this.pago.bancoTransferencia = ''
        this.pago.referencia = ''
      }
      this.calculos()
    },
    'act3': function (val) {
      if (!val) {
        this.pago.cheque = 0
        this.pago.fechaCheque = ''
        this.pago.bancoCheque = ''
        this.pago.numeroCheque = ''
      }
      this.calculos()
    },
    'dialog': function (val) {
      if (val) {
        this.pago.restante = this.form.credito
        this.form.descripcion = ''
        this.act1 = false
        this.act2 = false
        this.act3 = false
      } else {
        this.pago.restante = 0
      }
    },
    'bs': function (val) {
      if (val) {
        this.dolar = false
        this.form.moneda = 'BsS'
        this.actualizarMontos()
        this.calculos()
      } else {
        this.dolar = true
        this.form.moneda = '$'
      }
    },
    'dolar': function (val) {
      if (val) {
        this.bs = false
        this.form.moneda = '$'
        this.actualizarMontos()
        this.calculos()
      } else {
        this.bs = true
        this.form.moneda = 'BsS'
      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarBancos();
      this.permisosBan = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta === 'Banco')
    },

    validarCrearBan () {
      return this.permisosBan?.accion?.includes('Crear')
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
      }, 300)
      this.$emit('close')
    },
    listarBancos () {
      Api.get('/banco')
        .then(res => {
          this.bancos = res.data
          this.bancos.map(data => {
            this.idBancosArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    actualizarMontos () {
      if (this.bs) {
        this.montoPagar = this.form.credito
        if (this.pago.efectivo > 0) {
          this.pago.efectivo *= this.form.tasaCompra
          this.pago.efectivo = Number.parseFloat(this.pago.efectivo).toFixed(2)
        }
        if (this.pago.transferencia > 0) {
          this.pago.transferencia *= this.form.tasaCompra 
          this.pago.transferencia = Number.parseFloat(this.pago.transferencia).toFixed(2)
        }
        if (this.pago.cheque > 0) {
          this.pago.cheque *= this.form.tasaCompra
          this.pago.cheque = Number.parseFloat(this.pago.cheque).toFixed(2)
        }
      } else {
        if (this.form.tasaCompra > 0) {
          this.montoPagar = this.form.credito / this.form.tasaCompra 
          if (this.pago.efectivo > 0) {
            this.pago.efectivo /= this.form.tasaCompra
            this.pago.efectivo = Number.parseFloat(this.pago.efectivo).toFixed(2)
          }
          if (this.pago.transferencia > 0) {
            this.pago.transferencia /= this.form.tasaCompra
            this.pago.transferencia = Number.parseFloat(this.pago.transferencia).toFixed(2)
          }
          if (this.pago.cheque > 0) {
            this.pago.cheque /= this.form.tasaCompra
            this.pago.cheque = Number.parseFloat(this.pago.cheque).toFixed(2)
          }
        }
      }
    },

    validarCampos () {
      if (this.act1) {
        if (this.pago.efectivo === 0 || this.pago.fechaPagoEfectivo === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Debe completar todos los campos con la forma de pago EFECTIVO'
          })
          return true
        }
      }
      if (this.act2) {
        if (this.pago.transferencia === 0 ||
           this.pago.fechaTransferencia === '' ||
           this.pago.bancoTransferencia === '' ||
           this.pago.referencia === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Debe completar todos los campos con la forma de pago TRANSFERENCIA'
          })
          return true
        }
      }
      if (this.act3) {
        if (this.pago.cheque === 0 ||
           this.pago.fechaCheque === '' || this.pago.bancoCheque === '' ||
           this.pago.numeroCheque === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: 'Debe completar todos los campos con la forma de pago CHEQUE'
          })
          return true
        }
      }
      if (this.form.descripcion === '') {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Debe completar el campo descripción'
        })
        return true
      }
      if (this.pago.total === 0) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Debe ingresar un monto por una forma de pago'
        })
        return true
      }
      if (this.form.credito < this.pago.total) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ha excedido el monto total a pagar'
        })
        return true
      }
      return false
    },

    calculos () {
      this.pago.total = this.pago.efectivo + this.pago.transferencia + this.pago.cheque
      this.pago.restante = this.montoPagar - this.pago.total
      this.pago.restante = Number.parseFloat(this.pago.restante).toFixed(2)
      if (this.pago.restante < 0) this.pago.restante = 0
    },

    save () {
      if (!this.validarCampos()) {
        if (this.pago.total === this.montoPagar) {
          if(this.bs) this.form.debito = this.pago.total
          else this.form.debito = this.pago.total * this.form.tasaCompra
          this.form.credito = 0
          this.form.estatus = 'Cancelada'
          this.form.cancelada = true
        } else {
          if (this.bs) {
            this.form.credito -= this.pago.total
            this.form.debito += this.pago.total
          } else {
            this.form.credito -= this.pago.total * this.form.tasaCompra
            this.form.debito += this.pago.total * this.form.tasaCompra
          }
        }
        let moneda = 'Bs'
        if (this.dolar) moneda = 'Dolar'
        let arrayPago = []
        let obj = {}
        if (this.pago.efectivo !== 0) {
          obj = {
            monto: Number.parseFloat(this.pago.efectivo),
            fechaCobro: this.pago.fechaPagoEfectivo,
            tasa: this.form.tasaCompra,
            moneda,
            efectivo: true,
            transferencia: false,
            cheque: false
          }
          arrayPago.push(obj)
        }
        if (this.pago.transferencia !== 0) {
          obj = {
            monto: Number.parseFloat(this.pago.transferencia),
            idBanco: this.pago.bancoTransferencia,
            fechaTransferencia: this.pago.fechaTransferencia,
            referencia: this.pago.referencia,
            tasa: this.form.tasaCompra,
            moneda,
            efectivo: false,
            transferencia: true,
            cheque: false
          }
          arrayPago.push(obj)
        }
        if (this.pago.cheque !== 0) {
          obj = {
            monto: Number.parseFloat(this.pago.cheque),
            idBanco: this.pago.bancoCheque,
            fechaCheque: this.pago.fechaCheque,
            numeroCheque: this.pago.numeroCheque,
            tasa: this.form.tasaCompra,
            moneda,
            efectivo: false,
            transferencia: false,
            cheque: true
          }
          arrayPago.push(obj)
        }
        this.form.pago = arrayPago
        this.form.idCuentaPorPagar = this.form._id
        Api.put('cxp', this.form)
          .then(response => {
            this.$emit('edited')
            this.$swal({
              icon: 'success',
              title: 'Modificacion exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.close()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
               // text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message);
            }
          })
      }
    }
  }
}
</script>
